module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unit) ? _c('div', {
    staticClass: "program-info-wrap"
  }, [_c('h2', [_vm._v(" " + _vm._s(_vm.informationType) + " Information ")]), _vm._v(" "), _c('p', {
    staticClass: "program-info"
  }, [_c('code', {
    staticClass: "program-info",
    domProps: {
      "innerHTML": _vm._s(_vm.programInfo)
    }
  })]), _vm._v(" "), (_vm.onlineAvailability) ? _c('p', [_c('b', [_vm._v("Online Availability:")]), _vm._v(" " + _vm._s(_vm.onlineAvailability))]) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3698e146","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/program_information.vue
// module id = 990
// module chunks = 1